import { Resources } from "Infrastructure/Translation/Resources";
import type { TOptions } from "i18next";
import type { ObjPathProxy } from "ts-object-path";
import { z } from "zod";

const validationResource = Resources.base.examination.validations;

export const getCreateOrderExaminationFormSchema = (
	t: (
		resourcePath: ObjPathProxy<unknown, string>,
		options?: TOptions,
	) => string,
) => {
	return z.object({
		orderId: z.number().int().positive(),
		examinationDate: z
			.string()
			.nonempty({ message: t(validationResource.examinationDate) }),
	});
};

export type CreateOrderExaminationFormModel = z.infer<
	ReturnType<typeof getCreateOrderExaminationFormSchema>
>;
